import { useContext } from "react";
import getConfig from "../configs/enrollmentTableConfig";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";
import useRemoveAction from "../actions/remove/useRemoveAction";
import useCreateAction from "../actions/create/useCreateAction";
import useEditAction from "../actions/edit/useEditAction";
import useListAction from "../actions/list/useListAction";
import { Card } from "react-bootstrap";
import useStatisticsAction from "../actions/statistics/useStatisticsAction";
import useEnrollmentListAction from "../actions/list/useEnrollmentListAction";
import useEnrollmentAction from "../actions/enrollment/useEnrollmentAction";
import useUnenrollmentAction from "../actions/unenrollment/useUnenrollmentAction";
import useUnpayAction from "../actions/unpay/useUnpayAction";
import usePayAction from "../actions/pay/usePayAction";

function EnrollmentPlayersPage(props: any) {
  const { filters, formDefaultValues } = props;

  const { user } = useContext(AuthContext);

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useEnrollmentListAction(user, filters);

  const {
    enrollmentInitializeFunction,
    actionTemplate: enrollmentActionTemplate,
  } = useEnrollmentAction(indexFunction, formDefaultValues);

  const { getFunction, actionTemplate: editActionTemplate } =
    useEditAction(indexFunction);

  const {
    unenrollmentInitializeFunction,
    actionTemplate: unenrollmentActionTemplate,
  } = useUnenrollmentAction(indexFunction, formDefaultValues);

  const {
    payInitializeFunction,
    actionTemplate: payActionTemplate,
  } = usePayAction(indexFunction, formDefaultValues);

  const {
    unpayInitializeFunction,
    actionTemplate: unpayActionTemplate,
  } = useUnpayAction(indexFunction, formDefaultValues);

  const {
    getFunction: getFunctionStatistics,
    actionTemplate: editActionTemplateStatistics,
  } = useStatisticsAction();

  /**<newActionsHooks**/

  /**
   * Table configuration definition
   */
  let tableConfig = getConfig({
    enrollmentInitializeFunction, // We pass the function to initialize a new element (used in the create button)
    indexFunction, // We pass the function to index the table
    getFunction, // We pass the function to get an element (used in the edit button)
    unenrollmentInitializeFunction,
    getFunctionStatistics,
    payInitializeFunction,
    unpayInitializeFunction,
    /**newActionsTableConfig**/
  });
  setTableConfig(tableConfig);

  return (
    <Card>
      <Card.Header className="d-flex align-items-center justify-content-between ps-3 text-bg-primary">
        <span>{t("players")}</span>
        <div>
          <BeelditTableHeaderActions
            actions={tableConfig.actions}
          ></BeelditTableHeaderActions>
        </div>
      </Card.Header>

      <Card.Body>
        {listActionTemplate}
        {enrollmentActionTemplate}
        {editActionTemplate}
        {unenrollmentActionTemplate}
        {editActionTemplateStatistics}
        {payActionTemplate}
        {unpayActionTemplate}
        {/* newTemplateActions */}
      </Card.Body>
    </Card>
  );
}

export default EnrollmentPlayersPage;
